import { Box, LinearProgress, Typography, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

const CustomLinearProgress: React.FC<{ value: number }> = ({ value }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box display={'flex'} alignItems={'center'}>
      <Box>
        <Typography className={classes.progressBarText} mr={2}>
          {t('leadQuestionnaireProgress')}
        </Typography>
      </Box>
      <Box sx={{ width: '100%', mr: 2 }}>
        <LinearProgress className={classes.progressBar} variant={'determinate'} value={value} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography className={classes.progressBarText}>{`${Math.round(value)}%`}</Typography>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  progressBar: {
    height: '8px',
    borderRadius: '0px',
    '&.MuiLinearProgress-root': {
      background: alpha(theme.palette.primary.main, 0.25),
    },
    '& .MuiLinearProgress-bar': {
      background: theme.palette.primary.main,
    },
  },
  progressBarText: {
    fontSize: theme.typography.pxToRem(13),
    color: theme.palette.greys.medium,
  },
}));

export default CustomLinearProgress;
